import { render, staticRenderFns } from "./brandSwiper.vue?vue&type=template&id=ae479d76&scoped=true"
import script from "./brandSwiper.vue?vue&type=script&lang=js"
export * from "./brandSwiper.vue?vue&type=script&lang=js"
import style0 from "./brandSwiper.vue?vue&type=style&index=0&id=ae479d76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae479d76",
  null
  
)

export default component.exports